import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import {useAppSelector} from '@/store/hooks.js';

// Mutation pour ajouter une nouvelle TVA
const ADD_VAT = gql`
  mutation AddVat($companyUuid: ID!, $rate: Float!) {
    addVat(newVatDto: {companyUuid: $companyUuid, rate: $rate}) {
      uuid
    }
  }
`;

// Hook personnalisé pour ajouter une TVA
export const useAddVat = (refetch) => {
  const user = useAppSelector((state) => state.auth.currentUser);
  const companyUuid = user.company.uuid;

  // Mutation pour ajouter une nouvelle TVA
  const [addVat, { loading: addLoading, error: addError }] = useMutation(ADD_VAT, {
    variables: { companyUuid },
    onCompleted: refetch // Rafraîchir les données après la mutation
  });

  return {
    addVat,
    addLoading,
    addError
  };
};
